import { Trans, useLingui } from '@lingui/react/macro'

import { H2 } from '../../_components/H2'
import { PrimaryButton } from '../../_components/PrimaryButton'

import { getLocalizedIndexImage, proPromptsImages } from './localizedImages'

import LazyImage from '@/components/LazyImage'
import { useLocale } from '@/hooks/routes'

export const ProPrompts: React.FC = () => {
  const { t } = useLingui()
  const locale = useLocale()
  const src = getLocalizedIndexImage(
    locale,
    '/images/index/three-prmopts-select.png?t=1',
    proPromptsImages,
  )

  return (
    <div className='flex flex-col items-center justify-center gap-3 space-y-12 md:flex-row'>
      <div className='flex max-w-[500px] flex-col items-center md:mr-12 md:items-start'>
        <H2 className='pt-3 text-center font-normal md:pt-6 md:text-left lg:font-bold'>
          <Trans>AI Music Generator That Provides Prompt Assistance</Trans>
        </H2>
        <p className='text-f-other-10 mt-2 text-center text-sm md:text-left md:text-xl'>
          <Trans>
            Stuck on where to start? Let our AI hand you several expertly
            crafted prompts that complete with genre, instruments, BPM, style
            and mood. Just pick your favorite or hit regenerate until the
            perfect one appears.
          </Trans>
        </p>
        <PrimaryButton href='/ai-music-generator' className='mt-6 md:mt-9'>
          <Trans>Create AI music now</Trans>
        </PrimaryButton>
      </div>
      <LazyImage
        width={720}
        height={480}
        src={src}
        alt={t`Turn Your Ideas into Music`}
      />
    </div>
  )
}
